import React from "react";
import { GoogleLogin } from "@react-oauth/google";
import config from "../../config";

/**
 * Shared Google Identity button for Login + Signup.
 * Emits the Google ID token (credential) to onCredential.
 */
export default function GoogleAuthButton({
  onCredential,
  disabled = false,
  text = "continue_with",
}) {
  const clientId = config.googleClientId;

  if (!clientId) {
    return (
      <p className="pi-login__google-missing" role="status">
        Google sign-in is not configured. Set REACT_APP_GOOGLE_CLIENT_ID.
      </p>
    );
  }

  return (
    <div className={`pi-login__google${disabled ? " is-disabled" : ""}`}>
      <GoogleLogin
        onSuccess={(response) => {
          const credential = response?.credential;
          if (!credential || typeof onCredential !== "function") return;
          onCredential(credential);
        }}
        onError={() => {
          if (typeof onCredential === "function") {
            onCredential(null, new Error("Google sign-in was cancelled or failed."));
          }
        }}
        useOneTap={false}
        theme="outline"
        size="large"
        text={text}
        shape="rectangular"
        width="100%"
        logo_alignment="left"
      />
    </div>
  );
}
